export default "__VITE_ASSET__C6p4nU$3__"